<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider>修改查询界面</el-divider>
        </div>
        <div @click="showWanSearch"
          style="padding:10px;text-align: center;color:red;text-decoration: underline;cursor: pointer;font-size: 16px;">
          注意：如果无需锁定手机，且需定制查询条件，可使用万能快查小程序，点我了解。</div>
        <div style="padding: 10px;margin-top: 20px;">
          <div style="display: flex;">
            <div style="width: 30%;">
              <div style="text-align: center;font-size: 20px;"><span
                  style="font-weight: bold;color: red;">1.</span>修改手机端查询参数</div>
              <div
                style="margin-top: 20px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div style="display: flex;align-items: center;">
                  标题：<span>
                    <el-input v-model="search_title" placeholder="请输入内容"></el-input>
                  </span>
                </div>
                <div style="display: flex;align-items: center;margin-top: 20px;">
                  条件1：<span>
                    <el-input v-model="first_condition" placeholder="请输入内容"></el-input>
                  </span>
                </div>
                <div style="display: flex;align-items: center;margin-top: 20px;">
                  条件2：<span>
                    <el-input v-model="second_condition" placeholder="请输入内容"></el-input>
                  </span>
                </div>
                <div style="display: flex;align-items: center;margin-top: 20px;">
                  <span>
                    <el-button type="primary" @click="saveSearchCondition">保存参数</el-button>
                  </span>
                </div>
              </div>
            </div>
            <!--图片界面-->
            <div style="width: 30%;">
              <div style="font-size: 20px;display: flex;justify-content: center;width:100%;">
                <span style="margin-left: -60px;"><span style="font-weight: bold;color: red;">2.</span>预览手机端查询界面</span>
              </div>



              <div style="display:flex; flex-direction: column; justify-content: center;margin-top: 20px;">
                <el-image style="width: 300px; height: 550px" :src="search_face_url" fit="fit"></el-image>

                <div style="position: relative;left:0px;top:-430px;display: flex;justify-content: center;width: 300px;">
                  <span style="font-size: 18px;">{{search_title}}</span>
                </div>

                <div style="position: relative;left:30px;top:-395px; ">
                  <div style="font-size: 16px;">{{first_condition}}:<span
                      style="color: #AAAAAA;">输入{{first_condition}}</span></div>
                  <div style="font-size: 16px;margin-top: 20px;">{{second_condition}}:<span
                      style="color: #AAAAAA;">输入{{second_condition}}</span></div>
                </div>
              </div>


            </div>



            <div style="width: 30%;">
              <div style="text-align: center;font-size: 20px;"><span
                  style="font-weight: bold;color: red;">3.</span>生成自定义查询二维码</div>
              <div style="display: flex;justify-content: center;margin-top: 20px;">
                <el-button @click="openCustomQRCodeDialog" type="primary">生成二维码</el-button>
              </div>
              <div style="margin: 20px;font-size:16px;">
                <div style="font-weight: bold;">特别说明:</div>
                <div style="margin-top: 10px;">如果要显示您刚才定制的界面,查询的家长和学生<span
                    style="color:red;">必须使用这里下载的二维码</span>识别使用，否则会显示系统默认的界面。</div>
                <div style="margin-top: 10px;">公众号关联小程序地址：</div>
                <div style="margin-top: 10px;">pages/index/index?scene=customize_username={{username}}</div>
              </div>
            </div>

          </div>
        </div>
      </el-col>
    </el-row>

    <!--显示二维码窗口-->
    <el-dialog width="40%" :close-on-click-modal="false" title="微信或QQ扫码打开小程序" :visible.sync="scanToOpenDialogVisible">
      <div style="display: flex;justify-content: center;align-items: center;">
        <div style="display: flex;flex-direction: column;">
          <div>用<span style="color: red;">微信</span>扫描右侧的小程序中可查看手机端查询界面效果.</div>
          <div style="margin-top: 20px;">请将右侧的小程序码下载下来分享给查成绩的人，这样查成绩的人才可以使用您刚才设置的查询界面。</div>
        </div>
        <div>
          <img :src="qrcode_url" style="width: 200px;height: 200px;" />
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadQrcode">下载二维码</el-button>
        <el-button type="primary" @click="scanToOpenDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>


   <!--显示万能快查-->
   <el-dialog width="60%" :close-on-click-modal="false" title="老师专用小程序" :visible.sync="wanSearchVisible">
     <div style="display: flex;justify-content: space-evenly;">
       <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;">
         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">发分班、发成绩</div>
         <div
           style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
         </div>
         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">万能快查小程序</div>
         <div style="display: flex;justify-content: center;"><img src="../assets/wansearch_weixin.jpg"
             style="width: 150px;height:150px;"></img></div>
         <div style="font-weight: bold;margin-top: 10px;">
           <!--            <div style="margin-bottom: 5px;">用途：可设置任意查询条件的查询系统</div> -->
           <div style="margin-bottom: 5px;">特点：</div>
           <div style="margin-bottom: 5px;">1.查询条件可以任意设置</div>
           <div style="margin-bottom: 5px;">2.适用于发分班、工资条等</div>
           <div style="margin-bottom: 5px;">3.可加入公众号，海报等</div>
         </div>
       </div>

       <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;">
         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">核对数据、补填资料
         </div>
         <div
           style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
         </div>

         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">核对信息小程序</div>
         <div style="display: flex;justify-content: center;"><img src="../assets/hdxx_qrcode.jpg"
             style="width: 150px;height:150px;"></img></div>
         <div style="font-weight: bold;margin-top: 10px;">
           <!-- <div style="margin-bottom: 5px;">用途：可核对任何Excel文件中数据</div> -->
           <div style="margin-bottom: 5px;">特点：</div>
           <div style="margin-bottom: 5px;">1.一对一核对安全保密</div>
           <div style="margin-bottom: 5px;">2.可补填、可修改，修改可留痕</div>
           <div style="margin-bottom: 5px;">3.查询条件可任意定制</div>
         </div>
       </div>

       <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;">
         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">评价打分、民主测评
         </div>

         <div
           style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
         </div>

         <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">打分测评小程序</div>
         <div style="display: flex;justify-content: center;"><img src="../assets/dfcp_qrcode.jpg"
             style="width: 150px;height:150px;"></img></div>
         <div style="font-weight: bold;margin-top: 10px;">
           <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
           <div style="margin-bottom: 5px;">特点：</div>
           <div style="margin-bottom: 5px;">1.一对一打分安全保密</div>
           <div style="margin-bottom: 5px;">2.可实名、可匿名</div>
           <div style="margin-bottom: 5px;">3.打分结果自动计算汇总</div>
         </div>
       </div>

     </div>
     <div slot="footer" class="dialog-footer">
       <el-button type="primary" @click="wanSearchVisible=false">我知道了</el-button>
     </div>
   </el-dialog>


  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.loadData()
    },
    data() {
      return {
        username: '',
        search_face_url: '/score/images/search_face.png',
        first_condition: '姓名',
        second_condition: '学号',
        search_title: '查询入口',
        scanToOpenDialogVisible: false,
        qrcode_url: '',

        wanSearchVisible: false
      }
    },
    methods: {
      loadData() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_customize.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            if (response.data.result === '1') {
              that.search_title = response.data.search_title
              that.first_condition = response.data.first_condition
              that.second_condition = response.data.second_condition
            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      back() {
        this.$router.go(-1)
      },
      saveSearchCondition() {
        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let requestUrl = '/score/web/_qrcode_generator.jsp'
        let that = this
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              search_title: that.search_title,
              first_condition: that.first_condition,
              second_condition: that.second_condition
            }
          }).then(function(response) {
            that.qrcode_url = response.data.qrcode_url
            that.$forceUpdate()
            load.close()

            that.$message.success('保存成功！')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      openCustomQRCodeDialog() {
        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        let requestUrl = '/score/web/_qrcode_generator.jsp'
        let that = this
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              search_title: that.search_title,
              first_condition: that.first_condition,
              second_condition: that.second_condition
            }
          }).then(function(response) {
            that.qrcode_url = response.data.qrcode_url
            that.$forceUpdate()
            that.scanToOpenDialogVisible = true
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      downloadQrcode() { // 保存二维码
        let requestUrl = this.qrcode_url
        this.downloadIamge(requestUrl, 'score_qrcode')
      },
      downloadIamge(imgsrc, name) { // 下载图片地址和图片名
        var image = new Image()
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function() {
          var canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

          var a = document.createElement('a') // 生成一个a元素
          var event = new MouseEvent('click') // 创建一个单击事件
          a.download = name || 'photo' // 设置图片名称
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
        }
        image.src = imgsrc
      },
      showWanSearch(){
        this.wanSearchVisible=true
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/search_condition.vue